import React, { useState } from "react";
import styles from "./ContactRequest.module.sass";
import cn from "classnames";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Filters from "../../components/Filters";
import Settings from "./Settings";
import Table from "./Table";
import Panel from "./Panel";
import Details from "./Details";
import { deleteMultipleContactRequests } from "../../services/contactRequest.service";

const navigation = ["Active", "New"];

const ContactRequest = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [visible, setVisible] = useState(false);
  const [selectedContactRequest, setSelectedContactRequest] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [contactRequests, setContactRequests] = useState([]);

  const handleSubmit = (e) => {
    alert();
  };

  // Fonction pour gérer la suppression des demandes sélectionnées
  const handleDeleteSelected = async () => {
    if (selectedIds.length === 0) return;
    
    try {
      // Appeler le service de suppression
      await deleteMultipleContactRequests(selectedIds);
      
      // Fermer le détail si l'élément sélectionné est supprimé
      if (selectedContactRequest && selectedIds.includes(selectedContactRequest.id)) {
        setSelectedContactRequest(null);
        setVisible(false);
      }
      
      // Mettre à jour la liste locale
      setContactRequests(prev => prev.filter(item => !selectedIds.includes(item.id)));
      
      // Réinitialiser les sélections
      setSelectedIds([]);
      
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      // Optionnel : vous pouvez ajouter un toast/notification ici plus tard
    }
  };

  return (
    <>
      <Card
        className={styles.card}
        title="Tickets"
        classTitle={cn("title-purple", styles.title)}
        classCardHead={cn(styles.head, { [styles.hidden]: visible })}
        head={
          <>
            <Form
              className={styles.form}
              value={search}
              setValue={setSearch}
              onSubmit={() => handleSubmit()}
              placeholder="Rechercher par nom ou email"
              type="text"
              name="search"
              icon="search"
            />
            <div className={styles.nav}>
              {navigation.map((x, index) => (
                <button
                  className={cn(styles.link, {
                    [styles.active]: index === activeIndex,
                  })}
                  onClick={() => setActiveIndex(index)}
                  key={index}
                >
                  {x}
                </button>
              ))}
            </div>
            <Filters
              className={styles.filters}
              title="voir 10 de 24 tickets"
            >
              <Settings />
            </Filters>
          </>
        }
      >
        <div className={cn(styles.row, { [styles.flex]: visible })}>
          <Table
            className={styles.table}
            activeTable={visible}
            setActiveTable={setVisible}
            search={search}
            onContactRequestSelect={setSelectedContactRequest}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            contactRequests={contactRequests}
            setContactRequests={setContactRequests}
          />
          <Details
            className={styles.details}
            onClose={() => setVisible(false)}
            contactRequest={selectedContactRequest}
          />
        </div>
      </Card>
      <Panel 
        selectedCount={selectedIds.length}
        onDelete={handleDeleteSelected}
        visible={selectedIds.length > 0}
      />
    </>
  );
};

export default ContactRequest;
